module.exports = __webpack_public_path__ + "media/intro.77a0444b.wav";